import { DataGridPro } from '@mui/x-data-grid-pro/DataGridPro';
import { DataGridProProps } from '@mui/x-data-grid-pro';
import { useCallback } from 'react';
import { useRootFontScale } from './useRootFontScale';

type BaseGridProps = Omit<
  DataGridProProps,
  | 'hideFooter'
  | 'pagination'
  | 'disableColumnMenu'
  | 'columnBufferPx'
  | 'rowBufferPx'
  | 'sortingMode'
  | 'sortingOrder'
  | 'columnHeaderHeight'
  | 'paginationMode'
  | 'pinnedColumns'
> & {
  disablePagination?: boolean;
};

export const BaseGrid = ({ disablePagination, ...props }: BaseGridProps) => {
  const getRowHeight = useCallback(() => {
    return 'auto';
  }, []);

  const scale = useRootFontScale();

  return (
    <DataGridPro
      {...props}
      hideFooterSelectedRowCount
      columnBufferPx={999999}
      rowBufferPx={420}
      sortingMode="server"
      sortingOrder={['desc', 'asc']}
      columnHeaderHeight={props.loading ? 0 : 42 * scale}
      rowHeight={52 * scale}
      hideFooter={disablePagination}
      pagination={!disablePagination}
      disableColumnMenu
      paginationMode={disablePagination ? undefined : 'server'}
      getRowHeight={getRowHeight}
      pinnedColumns={{
        right: ['actions'],
        left: ['select-action'],
      }}
    />
  );
};
